import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import '../../../assets/css/custom.css';
import { EmbeddedLoginForm, FormBackground } from '../../components/EmbeddedLoginForm';

interface Props {
  callback?: any;
  saveRegister?: boolean;
  title?: string;
}

export const LoginFormSharedComponent: FunctionComponent<Props> = ({ callback, saveRegister, title }) => {
  return (
    <GlobalLoginFormStyle>
      <EmbeddedLoginForm callback={callback} saveRegister={saveRegister} title={title} />
    </GlobalLoginFormStyle>
  );
};

const GlobalLoginFormStyle = styled.div`
  & ${FormBackground} {
    margin-top: 40px;
    width: 100%;
  }
`;
